<template>
  <VcInputModal
    data-qa="follow-up-dialog"
    :useOffset="false"
    showDialog
    closeOnEsc
    closeButton
    :title="$t('conversation.reminders.follow_up')"
    :okButtonLabel="$t('conversation.reminders.ok_button')"
    size="md"
    @onCloseButtonClicked="closeDialog"
    @onCancelClicked="closeDialog"
    @onOkClicked="saveReminder" >

    <template #content>
      <div class="reminder-content">
        <div class="reminder-form">
          <div class="reminder-title">{{ $t('conversation.reminders.set_reminder') }}</div>
          <VcFocusArea>
            <div class="reminder-form__input">
              <VcSelectField
                :preSelection="reminderOptions[0]"
                :items="reminderOptions"
                @selection-changed="onReminderSelected"/>
            </div>
            <div class="reminder-time-picker" v-if="reminderSelection.value === -1">
              <DatePicker v-model="reminderDate"
                          :label="$t('common.words.date')"
                          data-qa="reminder-date-input"
                          :min="reminderDate"/>
              <HourPicker v-model="reminderHour"
                          :label="$t('common.words.time')"
                          :amPmMode="amPmMode"
                          data-qa="reminder-hour-input"
                          :readonly="true"
                          prepend-inner-icon="icon-Clock" />
            </div>

            <div class="reminder-alert">
              <VcAlert type="info"
                       :body-text="$t('conversation.reminders.reminder_alert')" />
            </div>
          </VcFocusArea>
        </div>

        <div class="reminder-note">
          <div class="reminder-note__title">{{ $t('conversation.reminders.note_title') }}
            <span class="reminder-note__title--optional">({{ $t('conversation.reminders.optional') }})</span>
          </div>
          <VcFocusArea>
            <VcTextArea :messages="noteMessage"
                        height="100px"
                        :placeholder="$t('conversation.reminders.note_placeholder')"
                        v-model="reminderNote"
                        noResize />
          </VcFocusArea>
        </div>
      </div>
    </template>

  </VcInputModal>
</template>

<script>
import HourPicker from "@/modules/common/components/HourPicker/HourPicker";
import DatePicker from "@/modules/common/components/DatePicker/DatePicker";
import moment from "moment";
import {mapActions, mapGetters} from "vuex";
export default {
  name: 'FollowUpDialog',
  components: {HourPicker,DatePicker},
  props: {

  },
  data() {
    let now = new Date;
    now.setDate(now.getDate()+1);

    return {
      reminderSelection: {text: this.$t('conversation.reminders.follow_up_intervals.1_day'), value:1},
      reminderHour: null,
      reminderDate: now.toString(),
      reminderTime: now.toString(),
      reminderNote: '',
      reminderOptions: [
        {value: 1, text: this.$t('conversation.reminders.follow_up_intervals.1_day')},
        {value: 3, text: this.$t('conversation.reminders.follow_up_intervals.3_days')},
        {value: 7, text: this.$t('conversation.reminders.follow_up_intervals.1_week')},
        {value: 14, text: this.$t('conversation.reminders.follow_up_intervals.2_weeks')},
        {value: 30, text: this.$t('conversation.reminders.follow_up_intervals.1_month')},
        {divider: true},
        {value: 0, text: this.$t('conversation.reminders.follow_up_intervals.no_reminder_just_move'), icon: 'icon-No_reminder'},
        {divider: true},
        {value: -1, text: this.$t('conversation.reminders.follow_up_intervals.pick_time'), icon: 'icon-Calendar-day'}
      ],
      noteMessage: this.$t('conversation.reminders.note_message')
    }
  },
  created() {
    this.setReminderHour();
  },
  computed: {
    ...mapGetters("accountModule", ["account"]),
    amPmMode() {
      return this.account.business.time_format === '12h'
    },
  },
  methods: {
    ...mapActions('mattersModule', ['fetchMatterData']),
    setReminderHour() {
      const now = moment();
      const format = `${this.amPmMode ? 'hh:00 A' : 'HH:00'}`
      this.reminderHour = now.format(format);
    },
    closeDialog() {
      this.$emit('close_dialog')
    },
    saveReminder() {
      if(this.reminderSelection.value === -1) {
        const date = moment(this.reminderDate).format('YYYY-MM-DD')
        this.reminderTime = moment(`${date} ${this.reminderHour}`, `YYYY-MM-DD hh:mm:ss A ${moment.tz.guess()}`).format();
      }
      this.$emit('save_reminder', {date: this.reminderTime && this.reminderTime.toString() ,message: this.reminderNote})
    },
    onReminderSelected(item) {
      //If No Reminder selected
      if (item.value === 0) {
        this.reminderTime = null;
      }
      else {
        this.calculateReminderTime(item.value)
      }

      this.reminderSelection = item;
    },
    calculateReminderTime (value) {
      let now = new Date();

      if (value > 0 && value < 30) {
        this.reminderTime = new Date(now.setDate(now.getDate()+value));
      }
      else if (value === 30) {
        this.reminderTime = new Date(now.setMonth(now.getMonth()+1));
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.reminder-content {
  font-size: var(--font-size-small2);

  .reminder-form {
    .VcFocusArea {
      display:block;
    }
    &__input {
      margin-block: 6px 22px;
    }
  }

  .reminder-title {
    font-weight: 600;
    margin-bottom: 5px;
  }

  .reminder-time-picker {
    display: flex;
    gap:16px;

    .date-picker-container, .hour-picker {
      flex-basis: 50%;
    }
  }

  .reminder-alert {
    margin-top: 16px
  }

  .reminder-note {
    margin-top: 35px;

    &__title {
      font-weight: 600;
      margin-bottom: 5px;

      &--optional {
        font-weight: 500;
        color: $grey-color-23;
      }
    }
  }
}

</style>
